<div class="p-booking-info-mdl__additional-item">
  <!-- [12.1] サポート情報追加 -->
  <button
    id="support-information-open-button1"
    *ngIf="isAddNewSupport"
    [ngClass]="['p-booking-info-mdl__additional-open', isOpen ? 'is-open' : '']"
    aria-controls="additional5"
    [attr.aria-expanded]="isOpen"
    (click)="onClickShowSupport()"
  >
    <span
      class="p-booking-info-mdl__additional-open-title"
      [innerHTML]="'label.supportInformation.title1' | staticMsg"
    ></span>
    <span class="p-booking-info-mdl__additional-open-icon">
      <img src="assets/images/icon_add_primary_20.svg" width="20" height="20" alt="Open" />
    </span>
  </button>
  <!-- [12.2] サポート情報詳細 -->
  <div *ngIf="isOpen" id="additional5" [ngClass]="['p-booking-info-mdl__contents', isOpen ? 'is-open' : '']">
    <div class="p-booking-info-mdl__section">
      <div class="p-booking-info-mdl__block">
        <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01 p-booking-info-mdl__heading--has-edit">
          <h3 class="p-booking-info-mdl__heading-title">
            {{ 'label.supportInformation' | staticMsg }}
            <!-- [12.3] サポート情報追加 -->
            <asw-tooltip
              iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                'm_static_message-alt.helpIcon2' | staticMsg
              }} width=&quot;20&quot; height=&quot;20&quot;>"
              [tooltipContent]="'tooltip.supportInformation' | staticMsg"
              [displayAreaClass]="'p-booking-info-mdl__contents'"
            ></asw-tooltip>
          </h3>
          <!-- [12.5] サポート情報編集 -->
          <div class="p-booking-info-mdl__heading-btn">
            <asw-button
              *ngIf="isDisplayEditSupportInfo"
              size="xs"
              [label]="'label.editSupportInformation' | staticMsg"
              (click$)="onClickEditSupport()"
            >
            </asw-button>
          </div>
        </div>
        <!-- [12.6] サポート情報 -->
        <div class="p-booking-info-mdl__row">
          <div class="p-booking-info-mdl__support">
            <dl class="c-def-list02">
              <!-- [12.7] 歩行障がい情報 -->
              <ng-container *ngIf="data?.walk">
                <div class="c-def-list02__item">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.degreeOfWalking' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body">
                    <dl class="c-float-list01">
                      <ng-container *ngIf="data?.walkLevel">
                        <!-- [12.8] 歩行の程度 -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.walking.ability' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="data?.walkLevelDisplayValue"
                          ></dd>
                        </div>
                      </ng-container>
                      <!-- [12.9] 車いす情報 -->
                      <ng-container *ngFor="let wheelchair of data?.wheelchairData">
                        <ng-container *ngIf="wheelchair?.isNeededWheelchairDisplayValue">
                          <!-- [12.10] 車いす持ち込み有無 -->
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.useWheelchair' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="isNeededWheelchairDisplayValue(wheelchair?.isNeededWheelchairDisplayValue)"
                            ></dd>
                          </div>
                        </ng-container>
                        <ng-container
                          *ngIf="wheelchair?.isNeededWheelchair && wheelchair?.isWheelchairFoldableDisplayValue"
                        >
                          <!-- [12.11] 折りたたみ可否 -->
                          <div
                            *ngIf="
                              wheelchair?.isWheelchairFoldable === true || wheelchair?.isWheelchairFoldable === false
                            "
                            class="c-float-list01__item"
                          >
                            <dt class="c-float-list01__title" [innerHTML]="'label.foldingWheelchair' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="
                                isWheelchairFoldableDisplayValue(wheelchair?.isWheelchairFoldableDisplayValue)
                              "
                            ></dd>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="wheelchair?.isNeededWheelchair && !wheelchair?.isWheelchairFoldable">
                          <!-- [12.12] サイズ -->
                          <div
                            *ngIf="
                              wheelchair?.wheelchairDepth && wheelchair?.wheelchairWidth && wheelchair?.wheelchairHeight
                            "
                            class="c-float-list01__item"
                          >
                            <dt class="c-float-list01__title" [innerHTML]="'label.size' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="
                                wheelchairSizeLabel(
                                  wheelchair?.wheelchairDepth,
                                  wheelchair?.wheelchairWidth,
                                  wheelchair?.wheelchairHeight
                                )
                              "
                            ></dd>
                          </div>
                          <!-- [12.13] 重さ -->
                          <div class="c-float-list01__item" *ngIf="wheelchair?.wheelchairWeight">
                            <dt class="c-float-list01__title" [innerHTML]="'label.weight' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="wheelchairWeightLabel(wheelchair?.wheelchairWeight)"
                            ></dd>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="wheelchair?.isNeededWheelchair && wheelchair?.wheelchairTypeDisplayValue">
                          <!-- [12.14] 車いす種類 -->
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.wheelchairType' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="wheelchairTypeDisplayValue(wheelchair?.wheelchairTypeDisplayValue)"
                            ></dd>
                          </div>
                        </ng-container>
                        <ng-container
                          *ngIf="
                            wheelchair?.isNeededWheelchair &&
                            wheelchair?.wheelchairType === 'battery' &&
                            wheelchair?.wheelchairBatteryTypeDisplayValue
                          "
                        >
                          <!-- [12.15] バッテリータイプ -->
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.batteryType' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="getBatteryType(wheelchair?.wheelchairBatteryTypeDisplayValue ?? '')"
                            ></dd>
                          </div>
                        </ng-container>
                      </ng-container>
                    </dl>
                  </dd>
                </div>
              </ng-container>
              <ng-container *ngIf="data?.blind">
                <!-- [12.16] 視覚障がい -->
                <div class="c-def-list02__item c-def-list02__item--one">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.blind' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body" [innerHTML]="'label.applicable' | staticMsg"></dd>
                </div>
              </ng-container>
              <ng-container *ngIf="data?.deaf">
                <!-- [12.17] 聴覚障がい -->
                <div class="c-def-list02__item c-def-list02__item--one">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.deaf' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body" [innerHTML]="'label.applicable' | staticMsg"></dd>
                </div>
              </ng-container>
              <!-- [12.18] 妊婦情報 -->
              <ng-container *ngIf="data?.isPregnant">
                <div class="c-def-list02__item">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.pregnant' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body">
                    <dl class="c-float-list01">
                      <!-- [12.18] 医師情報 -->
                      <ng-container *ngIf="pregnantDoctors?.length < 2; else readonlyDoctor">
                        <ng-container *ngIf="data?.pregnantDoctorName; let doctorName">
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.doctorName' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="doctorName"
                            ></dd>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="this.data?.pregnantDoctorPhoneNumber; let phone">
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.doctorsContact' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="phone"
                            ></dd>
                          </div>
                        </ng-container>
                      </ng-container>
                      <!-- [12.18] 医師情報 -->
                      <ng-template #readonlyDoctor>
                        <ng-container *ngFor="let doctor of pregnantDoctors">
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.doctorName' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="doctor?.name"
                            ></dd>
                          </div>
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.doctorsContact' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="doctor?.phone?.number"
                            ></dd>
                          </div>
                        </ng-container>
                      </ng-template>
                      <ng-container *ngIf="pregnantDueDates.length < 2; else readonlyDueDate">
                        <!-- [12.22] 出産予定日 -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.expectedDate' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="pregnantDueDate | dateFormat : 'default_apiDate'"
                          ></dd>
                        </div>
                      </ng-container>
                      <ng-template #readonlyDueDate>
                        <ng-container *ngFor="let dueDate of pregnantDueDates">
                          <!-- [12.22] 出産予定日 -->
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.expectedDate' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="dueDate | dateFormat : 'default_apiDate'"
                            ></dd>
                          </div>
                        </ng-container>
                      </ng-template>

                      <ng-container *ngIf="pregnantConditions.length < 2; else readonlyCondition">
                        <!-- [12.23] 現在の状況 -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.condition' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="pregnantCondition"
                          ></dd>
                        </div>
                      </ng-container>
                      <ng-template #readonlyCondition>
                        <ng-container *ngFor="let condition of pregnantConditions">
                          <!-- [12.23] 現在の状況 -->
                          <div class="c-float-list01__item">
                            <dt class="c-float-list01__title" [innerHTML]="'label.condition' | staticMsg"></dt>
                            <dd
                              class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                              [innerHTML]="condition"
                            ></dd>
                          </div>
                        </ng-container>
                      </ng-template>
                    </dl>
                  </dd>
                </div>
              </ng-container>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
